import Container from "@/components/common/Container";
import Title from "./common/Title";

const BG_COLOR_DATA = [
  { bgColor: "#A21D34", title: "#A21D34" },
  { bgColor: "#060C29", title: "#060C29" },
  { bgColor: "#F8F8F9", title: "#F8F8F9" },
  { bgColor: "#000000", title: "#000000" },
  { bgColor: "#FFFFFF", title: "#FFFFFF" },
];

const Guidelines = () => (
  <Container>
    <Title
      textBlack
      customClass="pb-6 md:pb-8 xl:pb-10"
      SubTitle="UI Guidelines"
    />
    <Container small>
      <div>
        <div className="flex flex-col md:flex-row items-center pb-10 xl:pb-24">
          <div className="w-full md:w-4/12">
            <h3 className="text-xl lg:text-4xl font-medium text-black pb-6 md:pb-0">
              <span className="font-jost">Colors</span>
            </h3>
          </div>
          <div className="w-full md:w-8/12 flex">
            {BG_COLOR_DATA.map((value, index) => (
              <div
                key={value.title}
                className={`text-xs md:text-sm xl:text-base font-normal text-center justify-center items-end pb-2 lg:pb-4 flex ${
                  index % 2 === 0 && index !== 0 ? "text-black" : "text-white"
                } w-16 h-20 md:w-16 md:h-24 xl:w-32 xl:h-44 border border-l-0 border-gray-500/50`}
                style={{ backgroundColor: value.bgColor }}
              >
                <span className="font-jost">{value.title}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col md:flex-row pb-10 xl:pb-24">
          <div className="w-full md:w-4/12">
            <h3 className="text-xl lg:text-4xl font-medium text-black">
              <span className="font-jost">Typography</span>
            </h3>
          </div>
          <div className="w-full md:w-8/12">
            <p className="text-base font-normal text-justify text-black pt-6 md:pt-0 lg:pt-4">
              <span className="font-jost">
                We selected sleek and contemporary fonts that not only improve
                readability but also contribute to a modern aesthetic,
                guaranteeing an attractive and user-centric browsing experience.
              </span>
            </p>
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-center pb-20 xl:pb-24">
          <div className="w-full md:w-4/12">
            <h3 className="font-normal text-center md:text-start text-black mb-6 md:mb-0 text-[200px] leading-tight md:text-large md:leading-tight xl:text-[200px] xl:leading-tight">
              <span className="font-jost">Aa</span>
            </h3>
          </div>
          <div className="w-full md:w-8/12">
            <span className="text-xl md:text-3xl font-medium text-black pr-4 pb-4 inline-block font-jost">
              Jost
            </span>
            <span className="text-base font-normal font-jost text-black pb-4 inline-block">
              Semi Bold, Medium, Regular, Light
            </span>
            <div>
              <p className="text-base font-normal text-black tracking-[10px] pb-6 md:pb-4 lg:pb-0 break-words">
                <span className="font-jost">ABCDEFGHIJKLMNOPQRSTUVWXYZ</span>
              </p>
              <p className="text-base font-normal text-black tracking-[10px] pb-6 md:pb-4 lg:pb-0 break-words">
                <span className="font-jost">abcdefghijklmnopqrstuvwxyz</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Container>
  </Container>
);

export default Guidelines;
